import { useEffect } from 'react';
import Navigation from '../../components/base/Navigation';
import Footer from '../../components/base/Footer';
import CookieBanner from '../../components/base/CookieBanner';
import WhatsAppButton from '../../components/base/WhatsAppButton';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Altta Talent Studio - Agencia de Talento Femenino Premium | Zaragoza';
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f3f0]">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <CTASection />
      </main>
      <Footer />
      <CookieBanner />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;